import e from "react";
var _n = function n() {
  return (_n = Object.assign || function (e) {
    for (var n, t = 1, o = arguments.length; t < o; t++) for (var r in n = arguments[t]) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    return e;
  }).apply(this, arguments);
};
function t(e, n, t) {
  if (t || 2 === arguments.length) for (var o, r = 0, i = n.length; r < i; r++) !o && r in n || (o || (o = Array.prototype.slice.call(n, 0, r)), o[r] = n[r]);
  return e.concat(o || Array.prototype.slice.call(n));
}
var o = "undefined" != typeof window && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window.navigator.platform),
  r = e.forwardRef(function (r, i) {
    var u = r.slidesToShow,
      c = void 0 === u ? 3 : u,
      a = r.infinite,
      l = void 0 === a || a,
      s = r.transitionDuration,
      f = void 0 === s ? 300 : s,
      d = r.centerCurrentSlide,
      h = void 0 !== d && d,
      v = r.render,
      p = void 0 === v ? function (e) {
        return e.slides;
      } : v,
      g = function (n, o) {
        var r = o.infinite,
          i = o.slidesToShow,
          u = o.mode,
          c = void 0 === u ? "flex" : u;
        return e.useMemo(function () {
          var o = e.Children.toArray(n),
            u = o.length,
            a = r ? o.slice(u - (i + 2)) : [],
            l = r ? o.slice(0, i + 2) : [];
          return "flex" === c ? {
            slides: t(t(t([], a, !0), o, !0), l, !0).map(function (n, t) {
              return e.cloneElement(n, {
                style: {
                  flex: "0 0 ".concat(100 / i, "%")
                },
                key: t
              });
            }),
            slideCount: u,
            preSlidesCount: a.length
          } : {
            slides: t(t(t([], a, !0), o, !0), l, !0).map(function (n, t) {
              return e.cloneElement(n, {
                key: t
              });
            }),
            slideCount: u,
            preSlidesCount: a.length
          };
        }, [n, r, i]);
      }(r.children, {
        infinite: l,
        slidesToShow: c,
        mode: "flex"
      }),
      T = g.slides,
      m = g.slideCount,
      w = g.preSlidesCount,
      S = function (n) {
        var t = n.infinite,
          o = n.slidesToShow,
          r = n.slideCount,
          i = e.useState(0),
          u = i[0],
          c = i[1];
        return {
          previous: e.useCallback(function () {
            return c(function (e) {
              return t || e - 1 >= 0 ? e - 1 : 0;
            });
          }, [t]),
          next: e.useCallback(function () {
            return c(function (e) {
              return t || e + 1 < r - o ? e + 1 : r - o;
            });
          }, [t, r, o]),
          hasNext: !!t || u + o < r,
          hasPrevious: !!t || u > 0,
          currentIndex: u,
          currentStep: u >= r ? u - r : u < 0 ? u + r : u,
          totalSteps: t ? r : 1 + r - o,
          goToStep: c
        };
      }({
        infinite: l,
        slidesToShow: c,
        slideCount: m
      }),
      C = S.previous,
      x = S.next,
      b = S.goToStep,
      y = S.currentIndex;
    e.useImperativeHandle(i, function () {
      return {
        previous: C,
        next: x,
        goToStep: b
      };
    }, [C, x]);
    var M = e.useRef(null),
      k = e.useState(0),
      E = k[0],
      A = k[1],
      R = e.useState(!1),
      P = R[0],
      D = R[1];
    !function (n) {
      var t = n.wrapper,
        o = n.callback,
        r = n.measure,
        i = n.slidesToShow,
        u = n.mode,
        c = void 0 === u ? "flex" : u,
        a = e.useCallback(function () {
          return requestAnimationFrame(function () {
            if (t.current) if ("flex" === c) {
              var e = t.current.getBoundingClientRect();
              o(Math.round(e[r] / i));
            } else if ("fixed" === c) {
              var n = t.current.children[0];
              n.children.length > 0 && (e = n.children[0].getBoundingClientRect(), o(e[r]));
            }
          });
        }, [i, o]);
      e.useLayoutEffect(function () {
        return a(), window.addEventListener("resize", a), function () {
          return window.removeEventListener("resize", a);
        };
      });
    }({
      wrapper: M,
      callback: function callback(e) {
        E !== e && (D(!0), A(e));
      },
      slidesToShow: c,
      measure: "width",
      mode: "flex"
    }), e.useEffect(function () {
      P ? y < 0 || y >= m ? requestAnimationFrame(function () {
        return S.goToStep(function (e) {
          return e < 0 ? l ? m + e : 0 : e - m;
        });
      }) : requestAnimationFrame(function () {
        return D(!1);
      }) : (y >= m || y < 0) && setTimeout(function () {
        return D(!0);
      }, f);
    }, [P, y, m, f]);
    var L = function (n) {
        var t = e.useRef(!1),
          r = e.useRef(null),
          i = e.useRef(null),
          u = e.useState(0),
          c = u[0],
          a = u[1],
          l = function l() {
            setTimeout(function () {
              return a(0);
            }, 0), r.current = null, i.current = null, t.current = !1;
          };
        e.useEffect(function () {
          if (o) {
            var e = function e(_e) {
              1 === _e.touches.length && t.current && (_e.cancelable ? _e.preventDefault() : l());
            };
            return document.addEventListener("touchmove", e, {
              passive: !1
            }), function () {
              document.removeEventListener("touchmove", e);
            };
          }
        }, []);
        var s = e.useCallback(function (e) {
            if (e.changedTouches && e.changedTouches.length > 1) return null;
            var n = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
            r.current = e.changedTouches ? e.changedTouches[0].clientX : e.clientX, i.current = n;
          }, []),
          f = e.useCallback(function (e) {
            if (null !== r.current) {
              e.changedTouches && e.changedTouches.length > 1 && l();
              var n = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - r.current,
                u = (e.changedTouches ? e.changedTouches[0].clientY : e.clientY) - i.current;
              a(n), o && t.current && e.stopPropagation(), t.current || (Math.abs(u) > 10 * window.devicePixelRatio ? l() : Math.abs(n) > 5 * window.devicePixelRatio && (t.current = !0));
            }
          }, [r]),
          d = e.useCallback(function () {
            n(c), l();
          }, [c, n]),
          h = e.useCallback(function (e) {
            Math.abs(c) > 5 && (e.preventDefault(), e.stopPropagation());
          }, [c]);
        return {
          isTouching: null !== r.current,
          touchOffset: c,
          onTouchStart: s,
          onTouchMove: f,
          onTouchEnd: d,
          onClickCapture: h
        };
      }(e.useCallback(function (e) {
        var n = Math.round((e > 0 ? e + .3 * E : e - .3 * E) / E);
        if (l) S.goToStep(function (e) {
          return e - n;
        });else {
          if (0 === n) return;
          S.goToStep(function (e) {
            return e - n > m - c ? m - c : e - n < 0 ? 0 : e - n;
          });
        }
      }, [E, m, c, S.goToStep])),
      O = L.onTouchStart,
      X = L.onTouchMove,
      Y = L.onTouchEnd,
      q = L.onClickCapture,
      z = L.touchOffset - (y + w) * E + (h ? (c / 2 - .5) * E : 0),
      F = P || L.isTouching ? 0 : f,
      I = 100 / c * -(y + w) + (h ? 100 / c * (c / 2 - .5) : 0);
    return p(_n(_n({}, S), {
      slides: e.createElement("div", {
        style: {
          width: "100%",
          overflow: "hidden"
        },
        ref: M
      }, e.createElement("div", {
        onTouchStart: O,
        onTouchMove: X,
        onTouchEnd: Y,
        onMouseDown: O,
        onMouseMove: X,
        onMouseUp: Y,
        onMouseLeave: Y,
        onClickCapture: q,
        style: {
          display: "flex",
          flexDirection: "row",
          transform: "translateX(".concat(E ? "".concat(z, "px") : "".concat(I, "%"), ")"),
          transition: "transform ".concat(F, "ms ease"),
          touchAction: "pan-y pinch-zoom"
        }
      }, T)),
      slidesToShow: c,
      infinite: l,
      transitionDuration: f,
      centerCurrentSlide: h
    }));
  });
function i(e) {
  return function (t) {
    var o = t.currentStep,
      r = t.totalSteps,
      i = t.goToStep,
      u = t.infinite,
      c = Array.from(Array(r)).map(function (e, n) {
        return {
          index: n,
          onClick: function onClick() {
            return i(u ? (e = o, a = (t = n) + (c = r), l = t - c, s = Math.abs(a - e), f = Math.abs(e - l), s < (d = Math.abs(t - e)) ? a : f < d ? l : t) : n);
            var e, t, c, a, l, s, f, d;
          },
          isActive: n === o
        };
      });
    return e(_n({
      dots: c
    }, t));
  };
}
export default r;
export { i as generateDots };